// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取图形验证码 GET /auth/captcha */
export async function getCaptcha(options?: { [key: string]: any }) {
  return request<API.CaptchaResult>('/auth/captcha', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/auth/logout', {
    method: 'Get',
    ...(options || {}),
  });
}

export async function currentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUser>('/user/me', {
    method: 'GET',
    ...(options || {}),
  });
}
/** 获取谷歌验证码二维码和密钥 GET /two-factor/generate */
export async function generateTwoFactor(options?: { [key: string]: any }) {
  return request<API.TwoFactorGenerateResult>('/two-factor/generate', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 启用谷歌验证码 POST /two-factor/enable */
export async function enableTwoFactor(body: API.EnableTwoFactorParams, options?: { [key: string]: any }) {
  return request<API.StandardResponse<null>>('/two-factor/enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前用户菜单权限 GET /user/menu/current */
export async function getCurrentUserMenu(options?: { [key: string]: any }) {
  return request<API.CurrentUserMenuResult>('/user/menu/current', {
    method: 'GET',
    ...(options || {}),
  });
}
